import { DownOutlined, MenuOutlined } from '@ant-design/icons';
import { Button, Image, Menu } from 'antd';
import Select from 'antd/es/select';
import cn from 'classnames';
import DOMPurify from 'dompurify';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import '../../assets/styles/custom/components/chat_header.scss';
import { ReactComponent as Camera } from '../../assets/svg/icons/camera.svg';
import { ReactComponent as Help } from '../../assets/svg/icons/help.svg';
import { ReactComponent as Home } from '../../assets/svg/icons/home.svg';
import { ReactComponent as Messages, ReactComponent as MessagesSvg } from '../../assets/svg/icons/messages.svg';
import { ReactComponent as Picture } from '../../assets/svg/icons/picture.svg';
import { ReactComponent as UserCircle } from '../../assets/svg/icons/user-circle.svg';
import { ReactComponent as Users } from '../../assets/svg/icons/users.svg';
import DateHumanizeHelper from '../../helpers/DateHumanizeHelper';
import { messageData } from '../../helpers/Dialogs';
import { getCommonRoutePath, getCurrentColor, isGlobalVersionTwo, isIframelessVersion, onUserImgError, statuses, } from '../../helpers/Helpers';
import { seeMoreTrigger, viewContentTrigger } from '../../helpers/MixpanelHelper';
import { sessionStorageWrapper } from '../../helpers/storageFactory';
import { ADD_PLUS_ONE_TO_CHAT_COUNTER, NEW_CHATS_MESSAGES, NEW_MESSAGES_COUNTER, } from '../../redux/actions/chatBoxActions';
import pusher from '../../system/services/PusherWrapper';
import Loader from '../Loader';
import InstitutionLogoHeader from '../institution-logo-header';
var UserHeader = function () {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var account = useSelector(function (state) { return state.account; }); // FIXME: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var main = useSelector(function (state) { return state.main; }); // FIXME: any
    var _a = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (state) { return state.widget; } // FIXME: any
    ), currentUniversityId = _a.currentUniversityId, isChatHeaderHidden = _a.isChatHeaderHidden, allGroupUniversitiesIds = _a.allGroupUniversitiesIds, isMobile = _a.isMobile;
    var _b = useSelector(function (state) { return state.chatBox; }), recentChats = _b.items, newMessagesNumber = _b.newMessages, isLoading = _b.isLoading; // FIXME: any
    var _c = useState(false), openChats = _c[0], setOpenChats = _c[1];
    var _d = useState(null), wrapperRef = _d[0], setWrapperRefState = _d[1];
    var listenerRef = React.useRef({ openChats: openChats, wrapperRef: wrapperRef });
    var page = window.location.href;
    useEffect(function () {
        listenerRef.current = { openChats: openChats, wrapperRef: wrapperRef };
    }, [openChats, wrapperRef]);
    useEffect(function () {
        if (!window.location.href.includes('/interaction/sign-in-redirect')) {
            dispatch({
                type: NEW_MESSAGES_COUNTER,
            });
        }
        document.addEventListener('mousedown', handleClickOutside);
        var channel = pusher.subscribe('messages');
        channel.bind('counter:new:' + account.account_info.id, function (data) {
            if (allGroupUniversitiesIds && allGroupUniversitiesIds.length) {
                if (allGroupUniversitiesIds.includes(data.universityId)) {
                    dispatch({
                        type: ADD_PLUS_ONE_TO_CHAT_COUNTER,
                    });
                }
            }
            else if (data.universityId === +currentUniversityId) {
                dispatch({
                    type: ADD_PLUS_ONE_TO_CHAT_COUNTER,
                });
            }
        });
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    var handleClickOutside = useCallback(function (event) {
        var _a = listenerRef.current, wrapperRef = _a.wrapperRef, openChats = _a.openChats;
        if (wrapperRef && !wrapperRef.contains(event.target) && openChats) {
            setOpenChats(false);
        }
    }, [listenerRef]);
    var clickOpenChats = useCallback(function () {
        if (!openChats) {
            dispatch({
                type: NEW_CHATS_MESSAGES,
                payload: {},
            });
        }
        setOpenChats(!openChats);
    }, [dispatch, openChats]);
    var goToDialog = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (item /* FIXME any */) {
        setOpenChats(false);
        if (item.type === statuses.speakersChat || item.type === statuses.liveChat) {
            navigate(getCommonRoutePath() +
                '/live-events/' +
                item.event_slug +
                (window.location.href.includes('/live-events/') ? '?direct=true' : ''));
        }
        else {
            navigate(getCommonRoutePath() +
                '/interaction/dialogs/' +
                item.id +
                (window.location.href.includes('/interaction/dialogs') ? '?direct=true' : ''));
        }
    }, [navigate]);
    var activeData = useMemo(function () {
        var activeTab = '';
        var tabName = '';
        if (page.includes('/chat-to-us')) {
            activeTab = 'users';
            tabName = 'Ambassadors';
        }
        else if (page.includes('/posts') || page.includes('/feed')) {
            activeTab = 'posts';
            tabName = 'Content';
        }
        else if (page.includes('/faq')) {
            activeTab = 'faqs';
            tabName = 'FAQs';
        }
        else if (page.includes('/group-chats')) {
            activeTab = 'chats';
            tabName = 'Group Chats';
        }
        else if (page.includes('/live-streams')) {
            activeTab = 'liveStreams';
            tabName = 'Live Streams';
        }
        else if (page.includes('/forum')) {
            activeTab = 'forum';
            tabName = 'Forum';
        }
        else if (!page.includes('/interaction')) {
            activeTab = 'home';
            tabName = 'Home';
        }
        else if (!page.includes('/sign-in')) {
            activeTab = 'login';
        }
        return { activeTab: activeTab, tabName: tabName };
    }, [page]);
    var tabsArrLength = useMemo(function () {
        return [main.showUsers, main.showPosts, main.showFaqs, main.showGroupChats, main.showForum].filter(function (item) { return item; }).length;
    }, [main]);
    var navigationItems = useMemo(function () {
        var activeTab = activeData.activeTab;
        var showUsers = main.showUsers, showPosts = main.showPosts, showFaqs = main.showFaqs, showGroupChats = main.showGroupChats, showLiveStreams = main.showLiveStreams, showForum = main.showForum;
        var commonRoutePath = getCommonRoutePath();
        var isCarousel = window.location.href.includes('carousel');
        var homeTab = {
            key: 'home',
            label: (React.createElement(NavLink, { to: commonRoutePath + '/', className: 'tab-link' + (activeTab === 'home' ? ' active' : '') }, "Home")),
            icon: React.createElement(Home, { className: activeTab === 'home' ? 'tab-img active' : 'tab-img' }),
        };
        var usersTab = {
            key: 'chat-to-us',
            label: (React.createElement(NavLink, { to: commonRoutePath + '/chat-to-us', className: activeTab === 'users' ? 'active' : '' }, "Ambassadors")),
            icon: React.createElement(UserCircle, { className: activeTab === 'users' ? 'tab-img active' : 'tab-img' }),
        };
        var postsTab = {
            key: 'posts',
            label: (React.createElement(NavLink, { to: commonRoutePath + '/posts', className: activeTab === 'posts' ? 'active' : '' }, "Content")),
            icon: React.createElement(Picture, { className: activeTab === 'posts' ? 'tab-img active' : 'tab-img' }),
        };
        var faqsTab = {
            key: 'faq',
            label: (React.createElement(NavLink, { end: true, to: commonRoutePath + '/faq', className: activeTab === 'faqs' ? 'active' : '' }, "FAQs")),
            icon: React.createElement(Help, { className: activeTab === 'faqs' ? 'tab-img active' : 'tab-img' }),
        };
        var groupChatsTab = {
            key: 'group-chats',
            label: (React.createElement(NavLink, { end: true, to: commonRoutePath + '/group-chats', className: activeTab === 'chats' ? 'active' : '' }, "Group Chats")),
            icon: React.createElement(Users, { className: activeTab === 'chats' ? 'tab-img active' : 'tab-img' }),
        };
        var liveStreamsTab = {
            key: 'live-streams',
            label: (React.createElement(NavLink, { end: true, to: commonRoutePath + '/live-streams', className: activeTab === 'liveStreams' ? 'active' : '' }, "Streams")),
            icon: React.createElement(Camera, { className: activeTab === 'liveStreams' ? 'tab-img active' : 'tab-img' }),
        };
        var forumsTab = {
            key: 'forum',
            label: (React.createElement(NavLink, { end: true, to: commonRoutePath + '/forum', className: activeTab === 'forum' ? 'active' : '' }, "Forum")),
            icon: React.createElement(Messages, { className: activeTab === 'forum' ? 'tab-img active' : 'tab-img' }),
        };
        var tabs = [homeTab];
        if (tabsArrLength > 1 && !isCarousel) {
            if (showUsers) {
                tabs.push(usersTab);
            }
            if (showPosts) {
                tabs.push(postsTab);
            }
            if (showFaqs) {
                tabs.push(faqsTab);
            }
            if (showGroupChats) {
                tabs.push(groupChatsTab);
            }
            if (showLiveStreams) {
                tabs.push(liveStreamsTab);
            }
            if (showForum) {
                tabs.push(forumsTab);
            }
        }
        return tabs;
    }, [activeData, main, tabsArrLength]);
    var goToSettings = useCallback(function () {
        sessionStorageWrapper.setItem('chatBoxGoBack', '/' + window.location.pathname.substring(window.location.pathname.indexOf('/') + 1));
        navigate(window.location.pathname.split('/')[0] + getCommonRoutePath() + '/interaction/settings');
    }, [navigate]);
    // FIXME: according to andt proptypes should be MenuInfo but handled as string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var hideDrop = useCallback(function (activeTab) {
        if (activeTab !== 'home' && activeTab !== 'posts') {
            seeMoreTrigger(activeTab, 'Header menu');
        }
        if (activeTab === 'posts') {
            viewContentTrigger('From navigation menu');
        }
        // with antd upgrade additional changes will be needed
        var elem = document.getElementsByClassName('tabs-select')[0];
        if (elem && 'click' in elem && typeof elem.click === 'function') {
            elem.click();
        }
    }, []);
    var renderOptionsDropdown = useCallback(function (_, isStreamPage) {
        var tabName = activeData.tabName;
        return (React.createElement(Select, { suffixIcon: isStreamPage && isMobile ? null : React.createElement(DownOutlined, null), labelInValue: true, "aria-label": "Select Page", className: cn('tabs-select', {
                'stream-page': isStreamPage && isMobile,
            }), value: {
                key: isStreamPage && isMobile ? (React.createElement(MenuOutlined, null)) : tabsArrLength > 1 && tabName ? (tabName) : ('Home'),
            }, popupClassName: "tab-options-dropdown tab-options-dropdown-antd", dropdownMatchSelectWidth: false, dropdownRender: function () { return (React.createElement("div", { className: "tab-options-dropdown-container" },
                React.createElement(Menu, { rootClassName: "navigation-menu navigation-menu-vertical", onClick: hideDrop, mode: "inline", items: navigationItems }))); } }));
    }, [main, activeData, tabsArrLength, navigationItems]);
    var isIframeLess = isIframelessVersion();
    var commonRoutePath = getCommonRoutePath();
    var isStreamPage = page.includes('/live-streams/');
    if (recentChats) {
        for (var _i = 0, recentChats_1 = recentChats; _i < recentChats_1.length; _i++) {
            var chat = recentChats_1[_i];
            if (chat.type === 4) {
                for (var _e = 0, _f = chat.ambassadors; _e < _f.length; _e++) {
                    var ambassador = _f[_e];
                    getCurrentColor(ambassador);
                }
            }
            else {
                getCurrentColor(chat);
            }
        }
    }
    var optionsDropdown = useMemo(function () {
        return renderOptionsDropdown(commonRoutePath, isStreamPage);
    }, [commonRoutePath, main, tabsArrLength, isStreamPage]);
    if (isChatHeaderHidden) {
        return React.createElement(React.Fragment, null);
    }
    // hides this block for webview on ambassador mob app
    if (account.isAuthFromMobApp) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        isIframeLess ? (React.createElement(InstitutionLogoHeader, { optionsDropdown: isStreamPage && isMobile ? optionsDropdown : null })) : null,
        React.createElement("div", { className: cn('chat-header-block', {
                'stream-page': isStreamPage && isMobile,
            }) },
            React.createElement("div", { className: "chat-header-left-block" }, !isGlobalVersionTwo &&
                (isMobile ? (optionsDropdown) : (React.createElement(Menu, { subMenuCloseDelay: 0, rootClassName: "navigation-menu navigation-menu-horizontal", onClick: hideDrop, mode: "inline", items: navigationItems })))),
            React.createElement("div", { className: "chat-header-right-block" },
                React.createElement("div", { className: "user-block" },
                    React.createElement(Button, { className: "new-messages-icon", onClick: clickOpenChats, "aria-label": "Messages list" },
                        React.createElement(MessagesSvg, null)),
                    +newMessagesNumber > 0 && (React.createElement("div", { className: "messages-counter", onClick: clickOpenChats }, newMessagesNumber)),
                    openChats && (React.createElement("div", { className: "conversations-drop", ref: function (node) {
                            setWrapperRefState(node);
                        }, style: {
                            height: isLoading || !recentChats || !recentChats.length ? '475px' : 'auto',
                        } },
                        React.createElement("div", { className: "conversations-header-text" }, "Conversations"),
                        isLoading ? (React.createElement(Loader, null)) : (React.createElement(React.Fragment, null, recentChats.length ? (React.createElement("div", { className: "conversations-list" }, recentChats.map(function (
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        item // FIXME: any
                        ) {
                            return item.type === 1
                                ? item.last_message && (React.createElement("div", { key: item.id, tabIndex: 0, className: 'conversation-item' +
                                        (item.new_messages
                                            ? ''
                                            : ' conversation-item-old'), onClick: function () { return goToDialog(item); }, onKeyPress: function () { return goToDialog(item); } },
                                    React.createElement("div", { className: "chat-item-head" },
                                        item.avatar ? (React.createElement(Image, { className: "chat-sa-avatar", src: item.avatar.sizes['70x70'] ||
                                                item.avatar.original, onError: onUserImgError, alt: item.name
                                                ? item.name
                                                    .slice(0, 1)
                                                    .toUpperCase()
                                                : 'D', wrapperStyle: { width: 'auto' } })) : (React.createElement("div", { className: "chat-msg-avatar-block", style: {
                                                backgroundColor: getCurrentColor(item),
                                            } },
                                            React.createElement("span", null, item.name
                                                ? item.name
                                                    .slice(0, 1)
                                                    .toUpperCase()
                                                : 'D'))),
                                        React.createElement("div", { className: "chat-sa-info" },
                                            React.createElement("div", { className: "sa-head-info" },
                                                React.createElement("div", { className: "sa-name" }, item.name),
                                                React.createElement("div", { className: "sa-date-new-message" }, DateHumanizeHelper(item.last_message.updated_at))),
                                            React.createElement("div", { className: "sa-tags" },
                                                item.first_ambassador.user_tags
                                                    .courses_types && (React.createElement("div", { className: "sa-course-block" },
                                                    React.createElement("span", { className: "sa-course-tag" }, item.first_ambassador
                                                        .user_tags
                                                        .courses_types[0]
                                                        .name))),
                                                item.first_ambassador.user_tags
                                                    .subject && (React.createElement("div", { className: "sa-subject-block" },
                                                    React.createElement("span", { className: "sa-subject-tag" }, item.first_ambassador
                                                        .user_tags
                                                        .subject[0].name))),
                                                item.first_ambassador.user_tags
                                                    .job_title && (React.createElement("div", { className: "sa-job-block" },
                                                    React.createElement("span", { className: "sa-course-tag" }, item.first_ambassador
                                                        .user_tags
                                                        .job_title[0].name)))))),
                                    React.createElement("div", { className: "chat-item-body" }, item.last_message && (React.createElement("span", { dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(messageData(item.last_message, item.reported), {
                                                ALLOWED_TAGS: [
                                                    ' ',
                                                    'a',
                                                    'b',
                                                    'span',
                                                    'p',
                                                    'br',
                                                ],
                                                ADD_ATTR: ['target'],
                                            }),
                                        } })))))
                                : item.last_message &&
                                    item.ambassadors && (React.createElement("div", { key: item.id, tabIndex: 0, className: 'conversation-item' +
                                        (item.new_messages
                                            ? ''
                                            : ' conversation-item-old'), onClick: function () { return goToDialog(item); }, onKeyPress: function () { return goToDialog(item); } },
                                    React.createElement("div", { className: "chat-item-head" },
                                        item.ambassadors && (React.createElement("div", { className: "chat-header-members-view" }, item.ambassadors.map(function (
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        ambassador // FIXME: any
                                        ) { return (React.createElement("div", { key: ambassador.id, className: "chat-random-img-block" }, ambassador.avatar ? (React.createElement(Image, { className: "chat-name-img", src: ambassador
                                                .avatar
                                                .sizes['70x70'] ||
                                                ambassador
                                                    .avatar
                                                    .original, onError: onUserImgError, alt: ambassador.name
                                                ? ambassador.name
                                                    .slice(0, 1)
                                                    .toUpperCase()
                                                : 'D' })) : (React.createElement("div", { className: "chat-name-img", style: {
                                                backgroundColor: getCurrentColor(ambassador),
                                            } },
                                            React.createElement("span", null, ambassador.name
                                                ? ambassador.name
                                                    .slice(0, 1)
                                                    .toUpperCase()
                                                : 'D'))))); }))),
                                        React.createElement("div", { className: "chat-sa-info" },
                                            React.createElement("div", { className: "sa-head-info" },
                                                React.createElement("div", { className: "sa-name" }, item.name),
                                                React.createElement("div", { className: "sa-date-new-message" }, DateHumanizeHelper(item.last_message.updated_at))))),
                                    React.createElement("div", { className: "chat-item-body" }, item.last_message && (React.createElement("span", { dangerouslySetInnerHTML: {
                                            __html: DOMPurify.sanitize(messageData(item.last_message, item.reported), {
                                                ALLOWED_TAGS: [
                                                    ' ',
                                                    'a',
                                                    'b',
                                                    'span',
                                                    'p',
                                                    'br',
                                                ],
                                                ADD_ATTR: ['target'],
                                            }),
                                        } })))));
                        }))) : (React.createElement("div", { className: "conversations-not-found" },
                            React.createElement(MessagesSvg, { className: "not-found-messages-icon" }),
                            React.createElement("div", { className: "no-chats-title" }, "No Conversations"),
                            React.createElement("div", { className: "no-chats-text" }, "Start a conversation with an ambassador and you'll be notified of\n                                                    new messages here")))))))),
                React.createElement(Button, { className: "user-block", onClick: goToSettings, "aria-label": "Settings" },
                    account.account_info.avatar ? (React.createElement(Image, { className: "user-avatar", src: account.account_info.avatar.sizes['70x70'] || account.account_info.avatar.original, onError: onUserImgError, alt: account.account_info && account.account_info.name
                            ? account.account_info.name.slice(0, 1).toUpperCase()
                            : 'D' })) : (React.createElement("div", { className: "user-avatar user-avatar-t" },
                        account.account_info && account.account_info.name
                            ? account.account_info.name.slice(0, 1).toUpperCase()
                            : 'D',
                        ' ')),
                    !isMobile && React.createElement("span", { className: "user-text" },
                        "Hey, ",
                        account.account_info.name,
                        "!"))))));
};
export default UserHeader;
